module.exports = __webpack_public_path__ + "static/keytruda-subq-logo-345be4f79e127014e058245e6cdd0125.png";